import { timezones } from './timezones';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../shared/services/user.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { GCValidators } from '../../shared/validators/gc-validator';
import { Subject } from 'rxjs';
var SettingsComponent = (function () {
    function SettingsComponent(userService, snackBar, translate) {
        var _this = this;
        this.userService = userService;
        this.snackBar = snackBar;
        this.translate = translate;
        this.ngUnsubscribe = new Subject();
        this.timezones = timezones;
        this.currentTab = 0;
        this.user = {};
        this.profileForm = new FormGroup({
            title: new FormControl('none', [Validators.required]),
            prename: new FormControl('', [Validators.required, Validators.minLength(2)]),
            surname: new FormControl('', [Validators.required, Validators.minLength(2)]),
            alias: new FormControl('', [Validators.maxLength(30)]),
            timezone: new FormControl('', [Validators.required]),
            language: new FormControl('', [Validators.required]),
            caption: new FormControl('', []),
            emailFormat: new FormControl('', [Validators.required]),
        });
        this.passwordForm = new FormGroup({
            oldPassword: new FormControl('', [Validators.required]),
            password: new FormControl('', [Validators.required, GCValidators.validatePassword()]),
            confirmPassword: new FormControl('', [Validators.required, GCValidators.validatePasswordComparison()]),
        });
        this.profileForm.disable();
        userService.currentUser.takeUntil(this.ngUnsubscribe).subscribe(function (user) {
            if (!user) {
                return;
            }
            _this.user = user;
            _this.profileForm.controls['title'].setValue(user.gender === true ? 'male' : user.gender === false ? 'female' : 'none');
            _this.profileForm.controls['prename'].setValue(user.firstName);
            _this.profileForm.controls['surname'].setValue(user.lastName);
            _this.profileForm.controls['alias'].setValue(user.alias);
            _this.profileForm.controls['timezone'].setValue(user.timeZone);
            _this.profileForm.controls['language'].setValue(user.language);
            _this.profileForm.controls['caption'].setValue(user.enableCaptions);
            _this.profileForm.controls['emailFormat'].setValue(user.emailFormat);
            _this.profileForm.enable();
        });
    }
    SettingsComponent.prototype.saveSettings = function () {
        var _this = this;
        if (this.profileForm.valid) {
            this.profileForm.disable();
            this.userService
                .updateUser({
                firstName: this.profileForm.value.prename,
                lastName: this.profileForm.value.surname,
                gender: this.profileForm.value.title === 'male' ? true : this.profileForm.value.title === 'female' ? false : null,
                language: this.profileForm.value.language,
                enableCaptions: this.profileForm.value.caption || false,
                timeZone: this.profileForm.value.timezone,
                alias: this.profileForm.value.alias,
                emailFormat: this.profileForm.value.emailFormat,
            })
                .then(function (result) {
                _this.profileForm.enable();
                _this.translate
                    .get('SETTINGS.ALERT.saveSuccess')
                    .takeUntil(_this.ngUnsubscribe)
                    .subscribe(function (message) {
                    _this.snackBar.open(message, null, {
                        verticalPosition: 'bottom',
                        duration: 4000,
                        panelClass: ['b2a-success', 'bottom'],
                    });
                    _this.userService.getThisUser();
                });
            })
                .catch(function (error) {
                _this.profileForm.enable();
                _this.translate
                    .get('SETTINGS.ALERT.saveError')
                    .takeUntil(_this.ngUnsubscribe)
                    .subscribe(function (message) {
                    _this.snackBar.open(message, null, {
                        verticalPosition: 'bottom',
                        duration: 4000,
                        panelClass: ['b2a-error', 'bottom'],
                    });
                });
            });
        }
    };
    SettingsComponent.prototype.submitPasswordForm = function (e) {
        var _this = this;
        e.preventDefault();
        if (this.passwordForm.valid) {
            this.passwordForm.disable();
            this.userService
                .setPassword(this.passwordForm.value.oldPassword, this.passwordForm.value.password)
                .then(function (result) {
                _this.passwordForm.reset();
                _this.passwordForm.enable();
                _this.translate
                    .get('SETTINGS.ALERT.saveSuccess')
                    .takeUntil(_this.ngUnsubscribe)
                    .subscribe(function (message) {
                    _this.snackBar.open(message, null, {
                        verticalPosition: 'bottom',
                        duration: 4000,
                        panelClass: ['b2a-success', 'bottom'],
                    });
                });
            })
                .catch(function (error) {
                _this.passwordForm.enable();
                _this.translate
                    .get('SETTINGS.ALERT.saveError')
                    .takeUntil(_this.ngUnsubscribe)
                    .subscribe(function (message) {
                    _this.snackBar.open(message, null, {
                        verticalPosition: 'bottom',
                        duration: 4000,
                        panelClass: ['b2a-error', 'bottom'],
                    });
                });
            });
        }
    };
    SettingsComponent.prototype.cancelSave = function (e) {
        e.preventDefault();
        this.userService.getThisUser();
        this.passwordForm.reset();
    };
    /**
     * On destroy cancel active subscriptions
     */
    SettingsComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    return SettingsComponent;
}());
export { SettingsComponent };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/settings/settings.component.ts.pre-build-optimizer.js